// Finar rev-B 19 — önceki yıl önerisinin uzun metni: ilk ~300 karakter + "devamını gör" (satır
// içi açılır, yan kaydırma yok). Saf: kesme noktası mümkünse son 40 karakter içindeki boşluk/satır
// sonu (kelime ortasından kesmez), yoksa tam sınır; kesilen metnin sonuna "…".

export const PRIOR_HINT_PREVIEW_CHARS = 300;
const WORD_BACKTRACK = 40;

export interface HintPreview {
  text: string;
  truncated: boolean;
}

export function priorHintPreview(full: string, limit = PRIOR_HINT_PREVIEW_CHARS): HintPreview {
  const chars = Array.from(full); // vekil çift (emoji) ortadan bölünmesin
  if (chars.length <= limit) return { text: full, truncated: false };
  let cut = limit;
  for (let i = limit; i > limit - WORD_BACKTRACK && i > 0; i -= 1) {
    if (/\s/.test(chars[i] ?? "")) {
      cut = i;
      break;
    }
  }
  return { text: `${chars.slice(0, cut).join("").trimEnd()}…`, truncated: true };
}
